import { Repository } from "src/firebase/firestore/repository";
import { Slot } from "./types/slot.entity";

class SlotRepository extends Repository<Slot> {
  constructor() {
    super("slots");
  }
}

export const slotRepository = new SlotRepository();
